import { Link } from 'react-router-dom';
import { useState } from 'react';
import { 
  FaHome, 
  FaServicestack, 
  FaInfoCircle, 
  FaPhone, 
  FaRocket, 
  FaUserTie,
  FaCalculator,
  FaBars,
  FaTimes,
  FaCreditCard,
  FaTasks
} from 'react-icons/fa';

// import ThemeToggle from './ThemeToggle';
import logo from '../images/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav>
      <div className="nav-container">

        {/* Brand Logo */}
        <div className="nav-brand">
          <Link to="/" className="brand-link" onClick={closeMenu}>
            <div className="logo-container">
              <img src={logo} alt="Loan Made Easy Logo" className="nav-logo" />
            </div>
            <span className="brand-text">Loan Made Easy</span>
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="nav-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>

          <li>
            <Link to="/" onClick={closeMenu}>
              <FaHome /> Home
            </Link>
          </li>

          <li>
            <Link to="/services" onClick={closeMenu}>
              <FaServicestack /> Services
            </Link>
          </li>

          <li>
            <Link to="/emi-calculator" onClick={closeMenu}>
              <FaCalculator /> EMI Calculator
            </Link>
          </li>

          {/* NEW TRACK STATUS BUTTON */}
          <li>
            <Link 
              to="/track-status" 
              className="track-status-link"
              onClick={closeMenu}
            >
              <FaTasks /> Track Status
            </Link>
          </li>

          <li>
            <Link to="/cibil-score" onClick={closeMenu}>
              <FaCreditCard /> Check CIBIL Score
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={closeMenu}>
              <FaPhone /> Contact
            </Link>
          </li>

          <li>
            <Link to="/about" onClick={closeMenu}>
              <FaInfoCircle /> About
            </Link>
          </li>

        </ul>

        {/* Right Side Buttons */}
        <div className="nav-buttons">

          <Link 
            to="/admin" 
            className="admin-btn-header" 
            onClick={closeMenu}
          >
            <FaUserTie /> Admin
          </Link>

          <Link 
            to="/apply" 
            className="apply-btn-header" 
            onClick={closeMenu}
          >
            <FaRocket /> Apply Now
          </Link>

        </div>

        {/* <div className="nav-actions">
          <ThemeToggle />
        </div> */}

      </div>
    </nav>
  );
};

export default Navbar;